import type { PhoneNumber } from 'lib-shared-legacy-types';
import { FC, useCallback } from 'react';

import { ConfirmModal } from 'components/shared/confirmModal/components/confirmModal';
import type { WithPhoneNumbersInjectedProps } from 'hocs';

import PrettyNumber from '../PrettyNumber';

type PropsT = {
  isShown: boolean;
  number: PhoneNumber | null;
  onHide: () => void;
} & WithPhoneNumbersInjectedProps;

const ReleaseNumberModal: FC<PropsT> = ({
  isShown,
  phoneNumbers,
  number,
  onHide,
}) => {
  const { releaseAsyncStatus } = phoneNumbers;
  const isLoading = releaseAsyncStatus !== 'succeeded';

  const onRelease = useCallback(() => {
    if (!number) {
      return;
    }

    const { release, getItems } = phoneNumbers;

    release(number)
      .then(() => onHide())
      .then(() => getItems());
  }, [phoneNumbers, number, onHide]);

  if (!number) {
    return null;
  }

  return (
    <ConfirmModal
      isShown={isShown}
      headline="Are you sure?"
      confirmText="Confirm"
      cancelText="Cancel"
      confirmProps={{ isLoading }}
      confirm={onRelease}
      cancel={onHide}
    >
      <span>
        You are about to release the phone number:{' '}
        <PrettyNumber number={number} />
      </span>
    </ConfirmModal>
  );
};

export default ReleaseNumberModal;
